import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDigits'
})
export class FormatDigitsPipe implements PipeTransform {
  public transform(value: number): string {
    const arr = String(value).match(/^(\d+)((?:\.\d+)?)$/);

    if (arr === null) {
      return '';
    }

    return arr[1].replace(/(\d)(?=(?:\d{3})+$)/g, '$1 ') + arr[2];
  }
}
